import { useEffect } from 'react';
import { useGetFileHeadersQuery, useGetFileMetadataQuery } from '../../../../../api/organizationSlice';

/**
 * Component that manages loading headers for a single file
 * This component wraps the header query hook and handles loading logic
 */
export const FileHeaderLoader = ({ file, fileType, organizationId, onHeadersLoaded, historyDate }) => {
    const { data: headers } = useGetFileHeadersQuery(
        { organizationId, fileName: file.file_name, fileType: fileType, historyDate },
        { skip: !file.file_name || !organizationId }
    );

    useEffect(() => {
        if (headers && onHeadersLoaded) {
            // Safely extract and validate headers array
            const headersArray = Array.isArray(headers.headers) ? headers.headers : [];
            
            // Filter out non-string values and trim valid strings
            const trimmedHeaders = headersArray
                .filter(header => typeof header === 'string')
                .map(header => header.trim())
                .filter(header => header.length > 0); // Remove empty strings after trimming
            
            const headersToUse = { ...headers, headers: trimmedHeaders };
            onHeadersLoaded(file.file_name, headersToUse);
        }
    }, [headers, file.file_name, onHeadersLoaded]);

    return null; // This is a utility component that doesn't render anything
};

/**
 * Component that manages loading metadata for a single file
 * This component wraps the metadata query hook and handles loading logic
 */
export const FileMetadataLoader = ({ file, fileType, organizationId, onMetadataLoaded, historyDate }) => {
    const { data: metadata } = useGetFileMetadataQuery(
        { organizationId, fileName: file.file_name, fileType: fileType, historyDate },
        { skip: !file.file_name || !organizationId }
    );

    useEffect(() => {
        if (metadata && onMetadataLoaded) {
            onMetadataLoaded(file.file_name, metadata);
        }
    }, [metadata, file.file_name, onMetadataLoaded]);

    return null; // This is a utility component that doesn't render anything
};